// extracted by mini-css-extract-plugin
export default {"loader":"CssLoader_loader__Pb+yG","loader-animation":"CssLoader_loader-animation__TV4Di"};